import { forwardRef, type ButtonHTMLAttributes } from "react";
import {
  shellControlClassName,
  type ShellControlSize,
  type ShellControlVariant,
} from "@/components/layout/shellControlClasses";

interface ShellButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ShellControlVariant;
  size: ShellControlSize;
  align?: "center" | "start";
  round?: boolean;
}

export const ShellButton = forwardRef<HTMLButtonElement, ShellButtonProps>(
  ({ className, variant, size, align, round, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={shellControlClassName({ variant, size, align, round, className })}
      {...props}
    />
  ),
);

ShellButton.displayName = "ShellButton";
